var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundedDarkView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1461 -620.133)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1471 633.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.952,5.5A8.728,8.728,0,0,1,15.2,6.635,12.711,12.711,0,0,1,18.3,9.1a16.735,16.735,0,0,1,2.563,3.569.39.39,0,0,1,0,.349A16.735,16.735,0,0,1,18.3,16.588a12.711,12.711,0,0,1-3.1,2.465,8.728,8.728,0,0,1-4.249,1.135A8.728,8.728,0,0,1,6.7,19.053a12.711,12.711,0,0,1-3.1-2.465,16.735,16.735,0,0,1-2.563-3.569.39.39,0,0,1,0-.349A16.735,16.735,0,0,1,3.6,9.1,12.711,12.711,0,0,1,6.7,6.635,8.728,8.728,0,0,1,10.952,5.5Zm9.12,7.344a16.653,16.653,0,0,0-2.356-3.225A9.267,9.267,0,0,0,10.952,6.28,9.275,9.275,0,0,0,4.174,9.634a16.6,16.6,0,0,0-2.342,3.21,16.653,16.653,0,0,0,2.356,3.225,9.267,9.267,0,0,0,6.764,3.339,9.275,9.275,0,0,0,6.778-3.354A16.6,16.6,0,0,0,20.071,12.844Z",
    transform: "translate(-1 -5.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,13a3,3,0,1,1-3,3A3,3,0,0,1,16,13Zm0,5.215A2.218,2.218,0,1,0,13.78,16,2.22,2.22,0,0,0,16,18.215Z",
    transform: "translate(-6.046 -8.654)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedDarkView);
export default __webpack_public_path__ + "static/media/icon_rounded_dark_view.5b77698fa04e5e8c310a313302fa4408.svg";
export { ForwardRef as ReactComponent };